
import { Question } from '../types';

export const taj101MaddQuestions: Question[] = [
  {
    id: 'taj071',
    text: 'What does madd mean in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'To lengthen or extend the sound', isCorrect: true },
      { id: 'b', text: 'To shorten the sound', isCorrect: false },
      { id: 'c', text: 'To stop the sound', isCorrect: false },
      { id: 'd', text: 'To change the sound', isCorrect: false }
    ],
    explanation: 'Madd literally means to lengthen or to extend. Technically, it means the lengthening of sound in the letters of madd or the letters of līn.',
    topic: 'taj101'
  },
  {
    id: 'taj072',
    text: 'What are the three letters of madd?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Wāw sākinah preceded by a ḍammah (ُو)', isCorrect: true },
      { id: 'b', text: 'Yāʾ sākinah preceded by a kasrah (ِي)', isCorrect: true },
      { id: 'c', text: 'Alif (ا) preceded by a fatḥah', isCorrect: true },
      { id: 'd', text: 'Wāw sākinah preceded by a fatḥah (َو)', isCorrect: false }
    ],
    explanation: 'The three letters of madd are: wāw sākinah preceded by a ḍammah (ُو), yāʾ sākinah preceded by a kasrah (ِي), and alif (ا). The alif is always preceded by a fatḥah.',
    topic: 'taj101'
  },
  {
    id: 'taj073',
    text: 'What are the two letters of līn?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Wāw sākinah preceded by a fatḥah (َوْ)', isCorrect: true },
      { id: 'b', text: 'Yāʾ sākinah preceded by a fatḥah (َيْ)', isCorrect: true },
      { id: 'c', text: 'Wāw sākinah preceded by a ḍammah (ُوْ)', isCorrect: false },
      { id: 'd', text: 'Yāʾ sākinah preceded by a kasrah (ِيْ)', isCorrect: false }
    ],
    explanation: 'The two letters of līn are: wāw sākinah preceded by a fatḥah (َوْ) and yāʾ sākinah preceded by a fatḥah (َيْ).',
    topic: 'taj101'
  },
  {
    id: 'taj074',
    text: 'What are the two initial types of madd?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Madd aṣlī (the primary madd)', isCorrect: true },
      { id: 'b', text: 'Madd farʿī (the secondary madd)', isCorrect: true },
      { id: 'c', text: 'Madd ṭabīʿī (the natural madd)', isCorrect: false },
      { id: 'd', text: 'Madd lāzim (the compulsory madd)', isCorrect: false }
    ],
    explanation: 'Initially, madd is divided into two types: madd aṣlī (the primary madd) and madd farʿī (the secondary madd).',
    topic: 'taj101'
  },
  {
    id: 'taj075',
    text: 'What is madd aṣlī?',
    type: 'single',
    options: [
      { id: 'a', text: 'A madd where after the letter of madd there is no hamzah or sukūn', isCorrect: true },
      { id: 'b', text: 'A madd where after the letter of madd there is a hamzah', isCorrect: false },
      { id: 'c', text: 'A madd where after the letter of madd there is a sukūn', isCorrect: false },
      { id: 'd', text: 'A madd where the letter of madd is followed by a shadda', isCorrect: false }
    ],
    explanation: 'Madd aṣlī is that madd where after the letter of madd there is no hamzah (ء) or sukūn (ْ), e.g., نُوْحِيْهَا.',
    topic: 'taj101'
  },
  {
    id: 'taj076',
    text: 'What is the duration of madd aṣlī?',
    type: 'single',
    options: [
      { id: 'a', text: 'One alif (qaṣr)', isCorrect: true },
      { id: 'b', text: 'Two alifs', isCorrect: false },
      { id: 'c', text: 'Four alifs', isCorrect: false },
      { id: 'd', text: 'Five alifs (ṭūl)', isCorrect: false }
    ],
    explanation: 'The duration of madd aṣlī is one alif. One alif is referred to as qaṣr.',
    topic: 'taj101'
  },
  {
    id: 'taj077',
    text: 'What causes madd farʿī?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'A hamzah after the letter of madd', isCorrect: true },
      { id: 'b', text: 'A sukūn after the letter of madd', isCorrect: true },
      { id: 'c', text: 'A shadda after the letter of madd', isCorrect: false },
      { id: 'd', text: 'A kasrah before the letter of madd', isCorrect: false }
    ],
    explanation: 'Madd farʿī is that madd where after the letter of madd, there is a hamzah or sukūn.',
    topic: 'taj101'
  },
  {
    id: 'taj078',
    text: 'What are the two types of madd caused by hamzah?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Madd muttaṣil (joined madd)', isCorrect: true },
      { id: 'b', text: 'Madd munfaṣil (separated madd)', isCorrect: true },
      { id: 'c', text: 'Madd lāzim (compulsory madd)', isCorrect: false },
      { id: 'd', text: 'Madd ʿāriḍ (conditional madd)', isCorrect: false }
    ],
    explanation: 'The hamzah is a cause for two types of madd: madd muttaṣil (the joined madd) and madd munfaṣil (the separated madd).',
    topic: 'taj101'
  },
  {
    id: 'taj079',
    text: 'What is madd muttaṣil?',
    type: 'single',
    options: [
      { id: 'a', text: 'When the letter of madd and the hamzah are in the same word', isCorrect: true },
      { id: 'b', text: 'When the letter of madd and the hamzah are in separate words', isCorrect: false },
      { id: 'c', text: 'When a sukūn follows the letter of madd', isCorrect: false },
      { id: 'd', text: 'When a shadda follows the letter of madd', isCorrect: false }
    ],
    explanation: 'If after the letter of madd, the hamzah is in the same word together with the letter of madd, then it is madd muttaṣil, e.g., جَاءَ, جِيْءَ, سُوْءٌ.',
    topic: 'taj101'
  },
  {
    id: 'taj080',
    text: 'What is the duration of madd muttaṣil and madd munfaṣil?',
    type: 'single',
    options: [
      { id: 'a', text: 'Three or four alifs (tawassuṭ)', isCorrect: true },
      { id: 'b', text: 'One alif (qaṣr)', isCorrect: false },
      { id: 'c', text: 'Five alifs (ṭūl)', isCorrect: false },
      { id: 'd', text: 'Two alifs', isCorrect: false }
    ],
    explanation: 'The duration of madd muttaṣil and madd munfaṣil is three or four alifs. This is also referred to as tawassuṭ.',
    topic: 'taj101'
  }
];
